import { lazy } from 'react'

export const GCKLazy = lazy(() => import('./GCK'))
